<template>
  <div class="animated revealUp">
    <div class="white-wrapper ">
      <div class="d-flex justify-content-between">
        <div class="section-title mb-2">
        {{ $tc("view") }} {{ $tc("customer", 1) }} {{ $t("transactions") }}
      </div>
      <div class="d-flex justify-content-between">
       
       <multiselect
                   
                    :options="transactionType"
                    v-model="selectedType"
                    :searchable="true"
                    label="type_name"
                    track-by="type_id"
                    placeholder="Select Type"
                    @input="onSelectType($event)"
                    :allowEmpty="false"
                    :showLabels="false"
                  ></multiselect>
                  <div class=" ml-2 align-self-center mb-2">
            <b-dropdown
              name="listview"
              id="listview"
              variant="outline-blue"
              class=""
            >
              <template v-slot:button-content>
                {{ $t("viewing") }}&nbsp;
                <strong>{{ selectedvalue }}</strong>
                &nbsp;{{ $t("of") }}&nbsp;
                <strong>{{ rows }}</strong>
              </template>
              <b-dropdown-item
                v-for="(list, listIndex) in viewingnumbers"
                :key="listIndex"
                @click="onDropDownChangeValue(list.name)"
                href="#"
                >{{ list.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
      </div>
      </div>
     
      <div class="mt-3 mb-2">
       
        <div class="row">
          <!-- SELECT DROPDOWN -->
          <div
            v-if="  transactionList.length  ||fnbTransactionList.length "
            class="col-lg-4 col-xl-3 d-flex align-self-center mb-4"
          >
            <label class="d-block font-weight-bold">{{ $t("name") }}</label>
           :- {{ (transactionList[0] && transactionList[0].first_name) || (fnbTransactionList[0] && fnbTransactionList[0].first_name) || "-" }}
          </div>

          <div
          v-if="  transactionList.length  ||fnbTransactionList.length "

            class="col-lg-4 col-xl-3 d-flex align-self-center mb-4"
          >
            <label class="d-block font-weight-bold">{{ $t("Contact No") }}</label>
           :- {{ transactionList[0].cust_mobile || fnbTransactionList[0].cust_mobile}}
          </div>

          <div
          v-if="  transactionList.length  || fnbTransactionList.length "

            class="col-lg-4 col-xl-4 d-flex align-self-center mb-4"
          >
            <label class="d-block font-weight-bold">{{ $t("email") }}</label>
            :-{{ transactionList[0].cust_email || fnbTransactionList[0].cust_email}}
          </div>

            <div
            v-if="transactionList.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->

            <a
              target="_blank"
              @click="selectedTypeId == 1 ? onGetTransactionList('Y') : getCustomerFnbTransactions('Y')"
              title="Download as Excel"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
            <!-- <a
              target="_blank"
              @click="getConcessionItemSales((isExcel = 'N'), 'Y')"
              title="Download as PDF"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/pdf.svg"
                height="25"
                width="25"
              />
            </a> -->
          </div>
        
        </div>
        <div >
          <!-- SELECT DROPDOWN -->

          <div class="table" style="overflow-x: scroll">
           
            <table v-if="selectedTypeId==1" class="swc-report-table" border="1" id="myTable">
          <thead class="bg-lightgrey font-weight-bold">
            <tr>
              <th class="text-center">
                {{ $tc("Transaction Booking Date & Time") }}
              </th>
              <th class="border-bottom-0">{{ $t("Show Booking Code") }}</th>
              <th class="border-bottom-0">{{ $t("Screen Name ") }}</th>

              <th class="border-bottom-0">{{ $t("Cinema Name") }}</th>
              <th class="border-bottom-0">{{ $t("Film Name") }}</th>
              <th class="border-bottom-0">
                {{ $t("Show Date & Time") }}
              </th>
              <th class="border-bottom-0">
                {{ $t("Seats") }}
              </th>
              <th class="border-bottom-0">
                {{ $t("Amount") }}
              </th>
                  <th class="border-bottom-0">
                {{ $t("Payment Mode") }}
              </th>
              <th class="border-bottom-0">
                {{ $t("Offer | Voucher") }}
              </th>
              <th class="border-bottom-0">
                {{ $t("Voucher Code") }}
              </th>

              <th class="border-bottom-0">
                {{ $t("Is Refunded") }}
              </th>
              <th class="border-bottom-0">
                {{ $t("Refund date & time") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-if="transactionList.length">
              <tr
                  v-for="(user, userIndex) in transactionList"
                  :key="userIndex"
                >
                  <td class="text-left">{{ user.t_booking_date_time | fulldatemonparse }}</td>
                  <td class="text-left">{{ user.sb_booking_code }}</td>
                  <td class="text-left">{{ user.screen_name }}</td>
                  <td class="text-left">{{ user.cinema_name }}</td>
                  <td class="text-left">{{ user.film_name }}</td>

                  <td class="text-left">
                    {{ user.t_show_date | dateparse }} {{ user.t_show_time }}
                  </td>
                  <td class="text-left">{{ user.seats }}</td>
                  <td class="text-right">{{ user.total_amount.toFixed(MIN_FRACTION_DIGITS) }}</td>
                  <td class="text-left">{{ user.payment_mode }}</td>

                  <td class="text-left">
                    {{
                      user.offer_name
                        ? user.offer_name
                        : user.voucher_name
                        ? user.voucher_name
                        : "-"
                    }}
                  </td>
                  <td class="text-left">
                    {{
                      user.voucher_code
                        ? user.voucher_code
                        : "-"
                    }}
                  </td>
                  <td class="text-left">{{ user.t_refund_date_time ? "Y" : "N" }}</td>
                  <td class="text-left" v-if="user.t_refund_date_time">
                    {{ user.t_refund_date_time | fulldatemonparse }}
                  </td>
                  <td v-else>-</td>
                </tr>
            </template>
       
            <template
              v-if="!transactionList.length"
            >
              <td colspan="11">No Records</td>
            </template>
          </tbody>
        </table>
            <table   v-if="selectedTypeId==2" class="swc-report-table" border="1" id="myTable">
          <thead class="bg-lightgrey font-weight-bold">
            <tr>
              <th class="text-center">
                {{ $tc("Transaction Date & time") }}
              </th>
              <th class="border-bottom-0">{{ $t("Order Code") }}</th>
              <th class="border-bottom-0">{{ $t("Cinema ") }}</th>

              <th class="border-bottom-0">{{ $t("Items") }}</th>
              <th class="border-bottom-0">{{ $t("Show Date & Time") }}</th>
              
              <th class="border-bottom-0">
                {{ $t("Quantity") }}
              </th>
              <th class="border-bottom-0">
                {{ $t("Offer/Voucher") }}
              </th>
              <th class="border-bottom-0">
                {{ $t("Voucher Code") }}
              </th>
              <th class="border-bottom-0">
                {{ $t("Amount") }}
              </th>
               <th class="border-bottom-0">
                {{ $t("Payment Mode") }}
              </th>

              <th class="border-bottom-0">
                {{ $t("Is Refunded") }}
              </th>
              <th class="border-bottom-0">
                {{ $t("Refund date & time") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-if="fnbTransactionList.length">
              <tr v-for="(transaction, transactionIndex) in fnbTransactionList">
            

                <td class="text-left">{{ transaction.ft_date_time  }}</td>
                <td class="text-left">
  {{ transaction.order_code }} 
  {{ transaction.sb_booking_code ? `(${transaction.sb_booking_code})` : "" }}
</td>

                    <td class="text-left">{{
                transaction.cinema
                 }}</td>
                <td class="text-left">{{ transaction.item_names || transaction.item_names}}</td>
                <td class="text-left">{{transaction.show_date_time || "-"  }}</td>
                <td class="text-right">{{ transaction.quantity || 0 }}</td>

                <td class="text-left">
                  {{
                    // parseFloat(transaction.offer_price || 0).toFixed(
                    //   MIN_FRACTION_DIGITS
                    // )
                    transaction.ft_offer_name || transaction.ft_voucher_name ||"-"
                  }}
                </td>
                <td class="text-left">
                  {{
                    // parseFloat(transaction.offer_price || 0).toFixed(
                    //   MIN_FRACTION_DIGITS
                    // )
                    transaction.ft_voucher_code  ||"-"
                  }}
                </td>
                <td class="text-right">
                  {{
                    parseFloat(transaction.ft_total_amount || 0).toFixed(
                      MIN_FRACTION_DIGITS
                    )
                  }}
                </td>
                <td class="text-left">{{ transaction.payment_mode}}</td>
                <td class="text-left">{{ transaction.refund_datetime?"Y":"N"}}</td>
                <td class="text-left">{{ transaction.refund_datetime || "-"}}</td>
           
              </tr>
            </template>
       
            <template
              v-if="!fnbTransactionList.length"
            >
              <td colspan="14">No Records</td>
            </template>
          </tbody>
        </table>
            <b-pagination
            class="mt-2"
              v-model="currentPage"
              :total-rows="rows"
              @change="onChangePagination($event)"
              :per-page="perPage"
              aria-controls="my-table"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CinemasService from "@/services/CinemasService";
import UserService from "@/services/UserService";
import MovieService from "@/services/MovieService";
import MasterService from "@/services/MasterService";
import SetupService from "@/services/SetupService";
import moment from "moment-timezone";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import NoRecords from "@/components/Partials/NoRecords.vue";
import NewReportService from "@/services/NewReportService"

export default {
  components: { DatePicker, Multiselect, NoRecords },
  data() {
    return {
      customer_id: null,
      transactionType:[{type_id:1,type_name:"Ticket Transactions"},{type_id:2,type_name:"Fnb Transactions"}],
      transactionList: [],
      selectedType:{type_id:1,type_name:"Ticket Transactions"},
      selectedTypeId:1,
      fnbTransactionList:[],
      transactionListCopy: [],
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [
        // { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ],
      gridView: false,
      listView: true,
    };
  },
  beforeMount() {
    this.customer_id = this.$route.query.cust_id;
    this.getviewingnumber();
    this.fetchDAta()

  },
  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.fetchDAta()

      } else {
        this.currentPage = event;
        this.fetchDAta()

      }
    },
    onSelectType:function(event){
this.selectedType=event
this.selectedTypeId=event.type_id
this.fetchDAta();
    },
    fetchDAta:function(){
      if(this.selectedTypeId==1){
        this.onGetTransactionList("N");
      }
      else{
        this.getCustomerFnbTransactions("N");

      }
    },
    onGetTransactionList: function (isExcel) {
      this.transactionList = [];

      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        customer_id: this.customer_id
          ? this.customer_id
          : this.$route.query.cust_id,
          isExcel
      };
      console.log("payload :", payload);
      let loader = this.$loading.show();
      MasterService.getCustomerTransactions(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records && data.Records.length > 0) {
            this.transactionList = data.Records;
            this.transactionListCopy = data.Records;
            if (isExcel == "Y" && data.excelPath) {
              window.open(data.excelPath, "_blank");
            }
            else if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else if (data.Records && data.Records.length == 0) {
            this.$toasted.show("No Records Found.");
          } else {
            this.$toasted.show(data.message);
          }
          loader.hide();

        })
        .catch(error => {
          console.log(error);
          loader.hide();
        });
    },
    getCustomerFnbTransactions:function(isExcel){
      
      this.fnbTransactionList=[];
      let payload={
        limit:this.perPage,
        offset:(this.currentPage-1) * this.perPage,
        customer_id:this.customer_id?this.customer_id:this.$route.query.cust_id,
        isExcel
      }
      let loader = this.$loading.show();

      NewReportService.getCustomerFnbTransactions(payload)
      .then((response)=>{
        const { data } = response;
        if (data.status && data.Records && data.Records.length > 0) {     
               this.fnbTransactionList=data.Records
               if (isExcel == "Y" && data.excelPath) {
              window.open(data.excelPath, "_blank");
            }
              else if (data.totalRows >= 10) {
              this.rows = data.totalRows;
              this.selectedvalue="10"
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
        }
        loader.hide();

      })
      .catch(error => {
          console.log(error);
          loader.hide();
        });
    }
  },
};
</script>

<style scoped>
.sph-report th,
td {
  height: 30px;
}

.left-border {
  border-left: 1px solid #787878 !important;
  border-top: 0 !important;
  border-bottom: 1px solid #787878 !important;
  border-right: 0 !important;
}

.right-border {
  border-left: 0 !important;
  border-top: 0 !important;
  border-right: 1px solid #787878 !important;
  border-bottom: 1px solid #787878 !important;
}
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #787878;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #787878;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}

.gcamp-tr td {
  width: 13%;
  border: 1px solid #787878;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid #787878;
}

.swc-report-table td {
  white-space: nowrap;
}

.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid #787878 !important;
}

.swc_table_header th {
  border: 1px solid #787878 !important;
}
.borderOnly {
  border-left: 0px !important;
  border-top: 0px !important;
  border-bottom: 0px !important;
  border-right: 1px !important;
}

.no_border {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/customerTransactionComponents/customerTransactions.vue